"use strict";

// The voucher provider takes its platform down for this window, so every call
// that reaches it fails. Both ends of the app compare against UTC so a viewer's
// own clock or timezone cannot move the window.
export const MARKETPLACE_MAINTENANCE_WINDOW = {
    start: Date.UTC(2026, 8, 17, 6, 5, 0),
    end: Date.UTC(2026, 8, 17, 6, 40, 0),
};

export const MARKETPLACE_MAINTENANCE_MESSAGE =
    "The shop is closed for scheduled maintenance between 06:05 and 06:40 GMT on 17 September 2026. Please try again shortly.";

export function isMarketplaceUnderMaintenance(now = Date.now()) {
    return (
        now >= MARKETPLACE_MAINTENANCE_WINDOW.start &&
        now <= MARKETPLACE_MAINTENANCE_WINDOW.end
    );
}
